import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from '../../../../environments/environment';
import { MessageResponseDTO } from '../../dtos/chat.dto';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private socket: Socket;
  private joinedChats: Set<number> = new Set();
  private globalMessageListener?: (message: MessageResponseDTO) => void;

  constructor() {
    this.socket = io(environment.url.replace('/api', ''), {
      withCredentials: true,
      transports: ['websocket', 'polling']
    });
  }

  joinChat(chatId: number) {
    if (!this.joinedChats.has(chatId)) {
      if (this.socket.connected) {
        this.socket.emit('joinChat', `${chatId}`);
        this.joinedChats.add(chatId);
      } else {
        this.socket.once('connect', () => {
          this.socket.emit('joinChat', `${chatId}`);
          this.joinedChats.add(chatId);
        });
      }
    }
  }

  leaveChat(chatId: number) {
    this.socket.emit('leaveChat', `${chatId}`);
    this.joinedChats.delete(chatId);
  }

  onNewMessage(chatId: number, callback: (message: MessageResponseDTO) => void) {
    if (!this.joinedChats.has(chatId)) {
      this.joinChat(chatId);
    }
    return this.socket.on('newMessage', (message: MessageResponseDTO) => {
      if (message.chat.chat_id === chatId) {
        callback(message);
      }
    });
  }

  onMessageViewed(chatId: number, callback: (message: MessageResponseDTO) => void) {
    if (!this.joinedChats.has(chatId)) {
      this.joinChat(chatId);
    }
    return this.socket.on('messageViewed', (message: MessageResponseDTO) => {
      if (message.chat.chat_id === chatId) {
        callback(message);
      }
    });
  }

  onNewRating(chatId: number, callback: (idChat: number) => void) {
    if (!this.joinedChats.has(chatId)) {
      this.joinChat(chatId);
    }
    return this.socket.on('newRating', (idChat: number) => {
      if (idChat === chatId) {
        callback(idChat);
      }
    });
  }

  onNewMessageGlobal(callback: (message: MessageResponseDTO) => void) {
    if (this.globalMessageListener) {
      this.socket.off('newMessage', this.globalMessageListener);
    }

    this.globalMessageListener = (message: MessageResponseDTO) => {
      callback(message);
    };

    this.socket.on('newMessage', this.globalMessageListener);
    return this.socket;
  }

  onNewMessageForComponent(callback: (message: MessageResponseDTO) => void) {
    this.socket.on('newMessage', callback);
    return this.socket;
  }

  offNewMessageGlobal() {
    if (this.globalMessageListener) {
      this.socket.off('newMessage', this.globalMessageListener);
      this.globalMessageListener = undefined;
    }
  }

  offNewMessage(callback?: (message: MessageResponseDTO) => void) {
    if (callback) {
      this.socket.off('newMessage', callback);
    } else {
      this.socket.off('newMessage');
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.joinedChats.clear();
    }
  }
}
